














import { Component, Vue } from 'vue-property-decorator';
import axios from "axios";
import OldCookieNotice from './components/OldCookieNotice.vue';
import NewCookieNotice from "./components/NewCookieNotice.vue";
import LoadingSpinner from "./components/misc/LoadingSpinner.vue";
import CookieHelper from "./helpers/cookie-helper";

type TTheme = `a` | `b`;

@Component({
  components: { LoadingSpinner, NewCookieNotice, OldCookieNotice },
})
export default class App extends Vue {
  protected getsNewNotice = false;
  protected loading = true;
  private retries = 0;

  private get themeEndpointUrl(): string {
    if(window.location.hostname.includes(`localhost`) || window.location.hostname.includes(`ringana-local`)) {
      return `https://www.ringana-testing.com/cookienotice/version`;
    }
    return `/cookienotice/version`;
  }

  async created(): Promise<void> {
    if(CookieHelper.getCcnInteracted() && CookieHelper.checkVersion()) {
      this.loading = false;
      return;
    }
    this.loading = true;
    this.getsNewNotice = (await this.getTheme()) === `a`;
    this.loading = false;
  }

  mounted(): void {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type,consistent-return,func-names,wrap-iife
    (function () {
      if(typeof window.CustomEvent === `function`) return false;

      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      function CustomEvent(event: string, params: { bubbles: boolean; cancelable: boolean; detail: unknown }) {
        // eslint-disable-next-line no-param-reassign
        params = params || { bubbles: false, cancelable: false, detail: null };
        // eslint-disable-next-line no-var,vars-on-top
        var evt = document.createEvent(`CustomEvent`);
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
      }

      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      window.CustomEvent = CustomEvent;
    })();
  }

  private async getTheme(): Promise<TTheme> {
    try {
      return (await axios.get(this.themeEndpointUrl, { withCredentials: false })).headers[`rin-cookienotice-theme`];
    } catch(err) {
      await new Promise(resolve => setTimeout(resolve, 1000));
      if(this.retries < 10) {
        this.retries++;
        return this.getTheme();
      }
      return `a`;
    }
  }
}
